module.exports = __webpack_public_path__ + "static/img/tooltip-constellation-statistics.d205486.png";